"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M1.169 10.261C2.28 3.884 8.137.545 12.933 1.046l.584.062-.474.345c-2.074 1.506-3.317 3.49-3.59 6.03-.233 2.153.31 4.109 1.58 5.876 2.414 3.339 7.352 4.634 11.355 2.053l.507-.328-.169.58c-1.248 4.265-5.924 8.243-11.811 7.59C4.598 22.55.056 16.671 1.169 10.261m11.133-8.806c-4.465-.164-9.667 3.02-10.69 8.884-1.067 6.15 3.29 11.792 9.352 12.468 5.39.598 9.716-2.851 11.14-6.705-4.114 2.287-8.995.896-11.436-2.48C9.337 11.77 8.76 9.704 9.006 7.437l.066-.495c.358-2.247 1.474-4.062 3.23-5.486"
}), 'Sleep');
